import { CampaignsFilters, RevshareCampaign } from './types';
import { FilterOption } from '../../../components/ui';

export const DEFAULT_FILTERS: CampaignsFilters = {
  search: '',
  account: '',
  status: '',
  sortBy: '',
  sortDirection: 'desc',
  campaignType: '',
  trafficSource: '',
  fansFrom: null,
  incomeFrom: null,
};

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_DELAY = 500;

export const getSortingOptions = (t: (key: string) => string): FilterOption[] => [
  // Дата создания/↓
  { key: 'created_at', label: `${t('partner.partnerCampaigns.filters.sortCreatedAt')}` },
  { key: '-created_at', label: `${t('partner.partnerCampaigns.filters.sortCreatedAt')}` },
  // Фанатов/↓
  { key: 'subscribed_count', label: `${t('partner.partnerCampaigns.filters.sortSubscribers')}` },
  { key: '-subscribed_count', label: `${t('partner.partnerCampaigns.filters.sortSubscribers')}` },
  // Фанатов с >= 3 сообщениями/↓
  {
    key: 'subs.with_gte_3_chat_messages_count',
    label: `${t('partner.partnerCampaigns.filters.sortSubscribersWithMessages')}`,
  },
  {
    key: '-subs.with_gte_3_chat_messages_count',
    label: `${t('partner.partnerCampaigns.filters.sortSubscribersWithMessages')}`,
  },
  // Доход (общий)/↓
  {
    key: 'transactions_statistic.total',
    label: `${t('partner.partnerCampaigns.filters.sortIncome')}`,
  },
  {
    key: '-transactions_statistic.total',
    label: `${t('partner.partnerCampaigns.filters.sortIncome')}`,
  },
  // Доход (1 день)/↓
  {
    key: 'transactions_statistic.1',
    label: `${t('partner.partnerCampaigns.filters.sortIncomeOneDay')}`,
  },
  {
    key: '-transactions_statistic.1',
    label: `${t('partner.partnerCampaigns.filters.sortIncomeOneDay')}`,
  },
  // ARPU/↓
  { key: 'arpu', label: `${t('partner.partnerCampaigns.filters.sortArpu')}` },
  { key: '-arpu', label: `${t('partner.partnerCampaigns.filters.sortArpu')}` },
  // ROMI/↓
  { key: 'romi', label: `${t('partner.partnerCampaigns.filters.sortRomi')}` },
  { key: '-romi', label: `${t('partner.partnerCampaigns.filters.sortRomi')}` },
];

export const getStatusFilterOptions = (t: (key: string) => string): FilterOption[] => [
  { key: 'all', label: t('global.common.all') || 'Все' },
  { key: 'active', label: t('partner.partnerCampaigns.filters.statusActive') },
  { key: 'inactive', label: t('partner.partnerCampaigns.filters.statusInactive') },
  { key: 'in_moderation', label: t('partner.partnerCampaigns.filters.statusModeration') },
  // { key: 'waiting', label: t('partner.partnerCampaigns.filters.statusWaiting') },
  { key: 'canceled', label: t('partner.partnerCampaigns.filters.statusCanceled') },
];

export const getCampaignTypeFilterOptions = (t: (key: string) => string): FilterOption[] => [
  { key: 'all', label: t('global.common.all') || 'Все' },
  { key: 'free', label: 'FREE' },
  { key: 'free trial', label: 'Free Trial' },
];

export const getTrafficSourceFilterOptions = (t: (key: string) => string): FilterOption[] => [
  { key: 'only_fans', label: 'OnlyFans' },
  { key: 'reddit', label: 'Reddit' },
  { key: 'instagram', label: 'Instagram' },
  { key: 'tiktok', label: 'TikTok' },
  { key: 'google', label: 'Google' },
  { key: 'telegram', label: 'Telegram' },
  { key: 'twitter', label: 'Twitter' },
  { key: 'youtube', label: 'YouTube' },
  { key: 'another', label: t('partner.partnerCampaigns.filters.otherSource') },
];

export const getTableColumns = (t: (key: string) => string) => [
  { name: 'ID', key: 'id' },
  { name: t('partner.partnerCampaigns.table.campaigns'), key: 'campaign' },
  { name: t('partner.partnerCampaigns.table.statistics'), key: 'statistics', tooltip: t('partner.partnerCampaigns.table.statisticsTooltip') },
  { name: t('partner.partnerCampaigns.table.income'), key: 'income' },
  { name: t('partner.partnerCampaigns.table.status'), key: 'status' },
  { name: t('partner.partnerCampaigns.table.actions'), key: 'actions' },
];

export const getStatusLabels = (t: (key: string) => string) => ({
  in_progress: t('partner.partnerCampaigns.statusInProgress'),
  in_moderation: t('partner.partnerCampaigns.statusModeration'),
  waiting: t('partner.partnerCampaigns.statusWaiting'),
  canceled: t('partner.partnerCampaigns.statusCanceled'),
  completed: t('partner.partnerCampaigns.statusCompleted'),
});

export const getStatusColors = () => ({
  in_progress: { bg: 'bg-auth-surface', text: 'text-auth-ink', dot: 'bg-success' },
  in_moderation: { bg: 'bg-[#fff4e5]', text: 'text-warning', dot: 'bg-warning' },
  waiting: { bg: 'bg-[#e6f1fe]', text: 'text-partner', dot: 'bg-partner' },
  canceled: {
    bg: 'bg-auth-error-bg',
    text: 'text-auth-strength-weak',
    dot: 'bg-auth-strength-weak',
  },
  completed: { bg: 'bg-auth-surface', text: 'text-auth-muted', dot: 'bg-auth-muted' },
});

export const getCampaignTypeLabels = (t: (key: string) => string) => ({
  by_link: t('partner.partnerCampaigns.campaignTypeByLink'),
  by_campaign: t('partner.partnerCampaigns.campaignTypeByCampaign'),
  free: 'FREE',
  free_trial: 'Free-Trial',
});
